var _a;
import { __decorate, __metadata } from "tslib";
import angular from 'angular';
import { Component } from 'decorators';
import view from './inputs.view.html';
import './inputs.scss';
import inputKeys from './inputs.json';
import { BuilderFeatures } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderFeatures';
import { UndoRedoService } from 'modules/application/misc/UndoRedoService';
import { BuilderStore } from 'modules/application/detail/portal-submodule-builder/templates/builder/store/BuilderStore';
import { OutputChange } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/outputs/components/outputs/outputs.dispatcher';
import { findConditionOutputs, createOutputCondition } from 'modules/application/detail/portal-submodule-builder/templates/builder/aiAgent/state/Inputs';
import { immutableSplice } from 'data/array';
import { defaultClusterName } from '../../../../../../../../../../../app.constants';
import { hasPdfFileRestriction } from '../../../../utils/ModelUtils';
const builderStore = BuilderStore.getInstance();
const LOADING_DISPLAY_DURATION_MS = 200;
let AgentInputsComponent = class AgentInputsComponent {
    static $inject = ['$timeout', 'UndoRedoService'];
    //#endregion
    constructor($timeout, UndoRedoService) {
        //#endregion
        //#region Component State
        this.schemaString = '';
        this.forwardInput = {};
        this.defaultForwardInputKey = 'unsupportedContent';
        this.inputs = Object.values(inputKeys);
        this.inputsView = {};
        this.inputsFeatures = {};
        this.showPdfRestrictionTooltip = false;
        this.loading = false;
        //#region Lifecycle Hooks
        this.$onInit = () => {
            let cluster = defaultClusterName.toLowerCase();
            this.updateFilteredStates();
            Object.keys(this.inputs).forEach(key => {
                this.inputConfiguration.input[key] = this.inputConfiguration.input[key] || { enableInputForwarding: true };
                this.inputsView[key] = !this.inputConfiguration.input[key].enableInputForwarding;
                this.fillForwardOutput(key);
            });
            BuilderFeatures.aiInputsByCluster(cluster).then(clusterFeatures => {
                Object.keys(this.inputs).forEach(key => {
                    this.inputsFeatures[key] = BuilderFeatures.aiInputEnabled(clusterFeatures, key);
                    if (this.inputsFeatures[key] === false) {
                        this.inputConfiguration.input[key] = null;
                    }
                });
            });
            this.showPdfRestrictionTooltip = hasPdfFileRestriction(this.inputConfiguration?.model?.model);
        };
        this.$doCheck = () => {
            if (this.showPdfRestrictionTooltip === hasPdfFileRestriction(this.inputConfiguration?.model?.model)) {
                return;
            }
            this.loading = true;
            this.showPdfRestrictionTooltip = hasPdfFileRestriction(this.inputConfiguration?.model?.model);
            this.$timeout(() => {
                this.loading = false;
            }, LOADING_DISPLAY_DURATION_MS);
        };
        this.onDefaultForwardToggle = (event) => {
            event.preventDefault();
            const key = this.defaultForwardInputKey;
            if (this.inputsFeatures[key] === false) {
                return;
            }
            this.inputsView[key] = !event.detail.checked;
            this.inputConfiguration.input[key].enableInputForwarding = event.detail.checked;
            if (this.inputsView[key]) {
                this.deleteOutput(key);
            }
        };
        this.onToggleContentType = (contentType) => {
            contentType.preventDefault();
            const keys = Object.keys(this.inputConfiguration.input);
            const selectedContentTypes = contentType.detail.map(item => item.value);
            for (const key of keys) {
                if (this.inputsFeatures[key] === false) {
                    continue;
                }
                this.inputConfiguration.input[key].enableInputForwarding = !selectedContentTypes.includes(key);
                this.inputsView[key] = selectedContentTypes.includes(key);
                let forwardOutputKey = this.inputs[key]?.variableValueForward;
                if (this.inputsView[key] && this.getForwardOutputIndex(forwardOutputKey) >= 0) {
                    this.deleteOutput(key);
                }
            }
        };
        this.updateFilteredStates = () => {
            if (!this.states) {
                throw new Error('States object is undefined in AgentInputsComponent. Ensure that the "states" binding is provided.');
            }
            if (this.state.id === undefined) {
                throw new Error('State ID is undefined in AgentInputsComponent. Ensure that the "state" binding has a valid "id" property.');
            }
            this.filteredStates = angular.copy(this.states);
            delete this.filteredStates[this.state.id];
        };
        this.$timeout = $timeout;
        this.UndoRedoService = UndoRedoService;
    }
    //#endregion
    //#region Methods
    async $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
    }
    fillForwardOutput(key) {
        const forwardOutputKey = this.inputs[key]?.variableValueForward;
        const index = this.getForwardOutputIndex(forwardOutputKey);
        if (index >= 0) {
            this.forwardInput[key] = this.state.$conditionOutputs[index]?.stateId || 'fallback';
        }
    }
    async changeOutput({ newTarget, newTypeOfStateId }, key) {
        let forwardOutputKey = this.inputs[key]?.variableValueForward;
        let outputIndex = this.getForwardOutputIndex(forwardOutputKey);
        if (outputIndex < 0) {
            outputIndex = this.state.$conditionOutputs.length;
            this.addOutput(forwardOutputKey);
        }
        this.state.$conditionOutputs[outputIndex].typeOfStateId = newTypeOfStateId;
        this.state.$conditionOutputs[outputIndex].stateId = newTarget;
        this.updateBuilderState();
    }
    updateBuilderState(partialState) {
        const currentState = angular.copy(this.state);
        builderStore.setState({
            ...currentState,
            ...partialState,
        });
    }
    getForwardOutputIndex(variableForward) {
        const outputIndex = this.state.$conditionOutputs.findIndex(findConditionOutputs(variableForward));
        return outputIndex;
    }
    addOutput(variableForward) {
        const output = createOutputCondition(variableForward);
        this.state.$conditionOutputs = this.state.$conditionOutputs.concat(output);
        this.updateBuilderState();
    }
    async deleteOutput(key) {
        try {
            const forwardOutputKey = this.inputs[key]?.variableValueForward;
            const index = this.getForwardOutputIndex(forwardOutputKey);
            this.forwardInput[key] = '';
            if (index < 0) {
                return;
            }
            const output = this.state.$conditionOutputs[index];
            this.state.$conditionOutputs = immutableSplice(this.state.$conditionOutputs, index, 1);
            builderStore.setState({ ...this.state });
            const action = new OutputChange({
                state: this.state,
                output: output,
                newTarget: output.stateId,
            });
            await this.$dispatch(action);
        }
        catch (ex) {
            console.error(`Error during remove output for key '${key}':`, ex);
        }
    }
};
AgentInputsComponent = __decorate([
    Component({
        template: view,
        controllerAs: '$ctrl',
        bindings: {
            onAction: '&?',
            inputConfiguration: '<',
            forwardInput: '<',
            state: '=?',
            states: '=?',
        },
    }),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof UndoRedoService !== "undefined" && UndoRedoService) === "function" ? _a : Object])
], AgentInputsComponent);
export { AgentInputsComponent };
